exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form___Hn9mp {\n  width: 100%; }\n\n.loading___3onYg {\n  opacity: .5; }\n", "", {"version":3,"sources":["/Users/fdev/code/factorial/factorial-components/src/components/Form/src/components/Form/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAW,EACZ;;AAED;EACE,YAAW,EACZ","file":"index.scss","sourcesContent":[".form {\n  width: 100%;\n}\n\n.loading {\n  opacity: .5;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"form": "form___Hn9mp",
	"loading": "loading___3onYg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/fdev/code/factorial/factorial-components/styles"],"sourceMap":true}!./~/postcss-loader/lib?{"path":"/Users/fdev/code/factorial/factorial-components/webpack/postcss.config.js"}!./src/components/Form/index.scss
// module id = 84
// module chunks = 0